import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Parser from 'html-react-parser';
import { Link } from 'react-router-dom';
import 'moment-timezone';
import { slugify } from "../../helpers/general.helper";
import { API_URL } from '../../config/apiEndpoints';
import {withRouter} from 'react-router';
import CarouselItemSchedule from './carouselitemschedule.component';


class CarouselItemsSchedule extends Component {

    render() {
        return (
            <Fragment key={this.props.key}>
                <div className="row details-holder middle no-gutters" key={this.props.key}>
                    <CarouselItemSchedule card={this.props.card} cinema={this.props.cinema}/>
                </div>
                <div className="col-12 movie-image">
                    <Link to={`/film/${this.props.card.film.film_id}/${slugify(this.props.card.film.film_title)}`}>
                        <img alt={'Film'} src={API_URL + Parser(this.props.card.film.film_poster)} />
                    </Link>
                </div>
                <div className="col-12 title-holder">
                    {/* {this.props.card.film.favorite.length === 0 ?
                        <div className="favourites-icon"> <img src={ribbonIcon} onClick={() => this.addMovieOnFavourite(this.props.card.film)} /> </div> :
                        <div className="favourites-icon"><img src={ribbonIconActive} onClick={() => this.removeMovieFromFavorite(this.props.card.film)} /></div>} */}
                    <div className="title-item">{Parser(this.props.card.film.film_title)}</div>
                    <span className="year-item">
                        ({this.props.card.film.film_release_year})
                    </span>
                </div>
                {/* {this.props.card.schedule_film_status === 'premieră' && <div className={`film_status ${this.props.card.schedule_film_status.length > 0 ? this.props.card.schedule_film_status === "premieră" ? "premiera" : "" : ""}`}>{this.props.card.schedule_film_status}</div>} */}
                {this.props.card.schedule_film_status === 'premieră' && <div className="film_status premiera">{this.props.card.schedule_film_status}</div>}
                {this.props.card.schedule_film_status === 'avan' && <div className="film_status avan">{this.props.card.schedule_film_status}</div>}
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    showDropDown: state.errors.showDropDown
});
export default withRouter(connect(mapStateToProps, {})(CarouselItemsSchedule));





// WEBPACK FOOTER //
// ./src/SHARED/components/carousel/carouselitemsschedule.component.js